const slider = document.getElementById('u-tested-slider');
const handle = document.getElementById('u-tested-handle');
const divider = document.getElementById('u-tested-divider');
const beforePanel = slider.querySelector('.u-tested-before-panel');
let active = false;

function setPosition(percent) {
  percent = Math.max(0, Math.min(100, percent));
  handle.style.left = percent + '%';
  divider.style.left = percent + '%';
  beforePanel.style.width = percent + '%';
  var beforeLabel = slider.querySelector('.u-tested-before-label');
  var afterLabel = slider.querySelector('.u-tested-after-label');
  beforeLabel.style.opacity = percent < 10 ? '0' : '1';
  afterLabel.style.opacity = percent > 90 ? '0' : '1';
}

function getPercent(e) {
  const rect = slider.getBoundingClientRect();
  const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  return ((clientX - rect.left) / rect.width) * 100;
}

setPosition(50);

handle.addEventListener('mousedown', () => active = true);
handle.addEventListener('touchstart', () => active = true, { passive: true });
window.addEventListener('mouseup', () => active = false);
window.addEventListener('touchend', () => active = false);
window.addEventListener('mousemove', e => { if (active) setPosition(getPercent(e)); });
window.addEventListener('touchmove', e => { if (active) { e.preventDefault(); setPosition(getPercent(e)); } }, { passive: false });
slider.addEventListener('click', e => { if (!handle.contains(e.target)) setPosition(getPercent(e)); });